<template>
  <div class="container-fluid">
    <validation-observer ref="v-observer" v-slot="{ valid }">
      <div class="row">
        <div class="col table-responsive mt-2 pl-2">
          <h5 class="card-title text-muted">
            <strong> {{ $t("customer.basket") }} </strong>
          </h5>
          <div class="float-left d-inline-flex">
            <button
              class="btn btn-danger btn-sm text-center m-1 hideToSummary"
              @click="clearProductsBasket"
            >
              {{ $t("buttons.cleanBasket") }}
            </button>
          </div>
          <table class="table table-bordered table-striped p-2">
            <thead>
              <tr>
                <th scope="col">L.P.</th>
                <th class="width-mid" scope="col">
                  {{ $t("basket.product") }}
                </th>
                <th scope="col">{{ $t("basket.price") }}</th>
                <th scope="col" colspan="2">
                  {{ $t("basket.quantity") }}
                </th>
                <th scope="col" colspan="1">
                  {{ $t("products.availableQuantityLontex") }}
                </th>
                <th scope="col" colspan="1">
                  {{ $t("products.quantityBlocked") }}
                </th>
                <th v-if="order.status === 'edit'" scope="col" colspan="1">
                  {{ $t("products.sended") }}
                </th>
                <th v-else-if="order.status === 'new'" scope="col" colspan="2">
                  {{ $t("products.toTransport") }}
                </th>
                <th v-if="order.status === 'edit'" scope="col" colspan="1">
                  {{ $t("products.toTransport") }}
                </th>
                <th scope="col" colspan="1">
                  {{ $t("customer.netValue") }}
                </th>
                

                <!-- <th scope="col" colspan="1" >
                  {{ $t('products.netValue') }}
                </th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-if="order.lines.length == 0">
                <td colspan="12" class="text-center">
                  {{ $t("orders.empty") }}
                </td>
              </tr>
              <cart-line
                v-for="(line, index) in order.lines"
                :key="line.id"
                :line="line"
                :index-line="index"
                @quantity="handleQuantityChange(line, $event)"
                @quantityToBlocked="handleChangeQuantityToBlocked(line, $event)"
                @sample="handleChangeSampleInfo(line, $event)"
                @quantityToTransport="
                  handleChangeQuantityToTransport(line, $event)
                "
                @price="handlePriceChange(line, $event)"
                @etollsEmai="handleEtollEmaiChange(line, $event)"
                @etollsDateFrom="handleEtollDateFromChange(line, $event)"
                @description="handleDescriptionChange(line, $event)"
                @remove="removeProduct"
                @statusLine="handleStatusLine(line, $event)"
              />
            </tbody>
            <tfoot v-if="order.lines.length > 0">
              <tr>
                <td colspan="9" class="text-right">
                  {{ $t("customer.summary") }}
                </td>
                <td class="text-right">
                  {{ currencyDisplay(totalPrice, false) }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="text-center">
            <router-link
              to="/products"
              class="btn btn-secondary m-1 hideToSummaryBack"
            >
              {{ $t("buttons.addProductOrder") }}
            </router-link>
            <button
              :disabled="!valid"
              class="btn btn-theme-add m-1 hideToSummary"
              @click="onNextClick"
            >
              {{ $t("buttons.nextStep") }}
            </button>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import CartLine from "./ShoppingCartLine";
import { ValidationObserver } from "vee-validate";
import { currencyMixin } from "../mixins";

export default {
  components: { CartLine, ValidationObserver },
  mixins: [currencyMixin],
  data: function () {
    return {
      discountGlobalInputValue: 0,
    };
  },
  computed: {
    ...mapState("cart", ["order"]),
    ...mapState("currency", ["ratio"]),
    ...mapGetters("cart", ["totalPrice"]),
  },
  mounted() {
    this.$refs["v-observer"].validate();
  },
  methods: {
    ...mapActions("cart", ["checkCustomerExist"]),
    ...mapMutations("cart", [
      "changeQuantity",
      "removeProduct",
      "changeDescription",
      "changeStatusLine",
      "changeQuantityToBlocked",
      "changeQuantityToTransport",
      "changeSampleInfo",
      "changeEtollEmai",
      "changeEtollDateFrom",
      "changePrice",
      "setCartData",
    ]),
    handleEtollEmaiChange(line, $event) {
      this.changeEtollEmai({ line, change: $event });
    },
    handleEtollDateFromChange(line, $event) {
      this.changeEtollDateFrom({ line, change: $event });
    },
    handleQuantityChange(line, $event) {
      this.changeQuantity({ line, change: $event });
    },
    handleDiscountChange(line, $event) {
      this.changeDiscount({ line, change: $event, ratio: this.ratio });
    },
    handlePriceChange(line, $event) {
      this.changePrice({ line, change: $event, ratio: this.ratio });
    },
    handleDescriptionChange(line, $event) {
      this.changeDescription({ line, change: $event });
    },
    handleStatusLine(line, $event) {
      this.changeStatusLine({ line, change: $event });
    },
    handleChangeQuantityToBlocked(line, $event) {
      this.changeQuantityToBlocked({ line, change: $event });
    },
    handleChangeQuantityToTransport(line, $event) {
      this.changeQuantityToTransport({ line, change: $event });
    },
    handleChangeSampleInfo(line, $event) {
      this.changeSampleInfo({ line, change: $event });
    },
    onNextClick() {
      this.$refs["v-observer"].validate().then((result) => {
        if (result) {
          this.$router.push("/summary");
        }
      });
    },
    clearProductsBasket() {
      this.setCartData([]);
      localStorage.removeItem("cart");
    },
  },
};
</script>
